export const SERVICE_NAMESPACE = 'cta-automation-service';
export const DEEPLINK_MOCK_DATA_STORAGE_KEY = 'cta_service.deeplink_response_mock_data';
